import { ActionIcon, Box, Flex, AppShell } from "@mantine/core";
import SamblaLogo from "../../assets/sambla.svg";
import CloseIcon from "../../assets/close-icon.svg";
import { useDisclosure } from "@mantine/hooks";
// import LanguageSelector from "../languageToggle/LanguageSelector";
import ExitOnboarding from "../exitOnboarding";

export default function Header() {
  const [opened, { open, close }] = useDisclosure(false);
  return (
    <>
      <ExitOnboarding opened={opened} close={close} />
      <AppShell.Header
        bg="var(--wallet-color-sambla-red-shade-900)"
        withBorder={false}
      >
        <Flex justify="space-between" align="center" h="100%">
          <Box ml="1rem">
            <SamblaLogo />
          </Box>
          <Flex align="center">
            {/* <LanguageSelector /> */}
            <ActionIcon
              variant="transparent"
              onClick={() => open()}
              mr="1rem"
              ml="1rem"
            >
              <CloseIcon />
            </ActionIcon>
          </Flex>
        </Flex>
      </AppShell.Header>
    </>
  );
}
